module.exports = __webpack_public_path__ + "static/media/StarLord.7917722d.jpg";